import Router from 'next/router';

/**
 * The session id in the current route, or undefined when the user is not on a
 * session page.
 *
 * Lives apart from `useCurrentIds` despite being re-exported from it: the hooks
 * there pull in the feature-flag system and several atom trees, and this
 * function is called from request interceptors and other leaf utilities that
 * must not inherit that graph.
 */
export function getCurrentSessionId(): string | undefined {
  if (!Router.isReady) {
    return undefined;
  }

  const pathname = Router.pathname;
  if (!pathname.startsWith('/scribe/session')) {
    return undefined;
  }

  const { id: routeId } = Router.query;

  return Array.isArray(routeId) ? routeId[0] : routeId;
}
